import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const RHLayout = () => {
  return (
    <div className="dashboard-layout-container">
      <Navbar />
      <div className="dashboard-content-wrapper">
        <Sidebar />
        <main className="dashboard-main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default RHLayout;
